import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/safe/group',
  owner: '/home',
  authority: 'group',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};